export const HANDOFF_FRAGMENT_KEY = 'sb_handoff'

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

const destinationSite = (hostname) => {
  const host = hostname.toLowerCase().replace(/^www\./, '')
  if (host === 'rm.bonibeach.com') return 'boni_booking'
  if (host === 'bonibeach.com' || host.endsWith('.bonibeach.com')) return 'boni_hotel'
  return null
}

export function prepareOutboundHandoff({
  href = '',
  baseUrl = 'https://selong-belanak.com/',
  enabled = false,
  idFactory = () => globalThis.crypto?.randomUUID?.(),
} = {}) {
  let destination
  try {
    destination = new URL(href, baseUrl)
  } catch {
    return { url: href, handoffId: null, destinationSiteId: null }
  }

  const destinationSiteId = destinationSite(destination.hostname)
  if (!enabled || !destinationSiteId) {
    return { url: destination.toString(), handoffId: null, destinationSiteId }
  }

  let handoffId
  try {
    handoffId = idFactory()
  } catch {
    handoffId = null
  }
  if (!UUID_PATTERN.test(handoffId || '')) {
    return { url: destination.toString(), handoffId: null, destinationSiteId }
  }

  destination.hash = `${HANDOFF_FRAGMENT_KEY}=${encodeURIComponent(handoffId)}`
  return { url: destination.toString(), handoffId, destinationSiteId }
}
